import React from "react";
import PropTypes from "prop-types";
import MemberIcon from "../../../../../components/member-icon/member-icon";
import "./MentionUserItem.scss";

const MentionUserItem = (entry, search, highlightedDisplay, index, focused) => {
    const memberIconObj = { userNameFull: entry.display };
    return (
        <div className="mentionListRow">
            <MemberIcon member={memberIconObj} type={"user"} />
            {highlightedDisplay}
        </div>
    )
}

MentionUserItem.propTypes = {
    entry: PropTypes.object.isRequired,
    search: PropTypes.string.isRequired,
    highlightedDisplay: PropTypes.string.isRequired,
    index: PropTypes.number.isRequired,
    focused: PropTypes.bool.isRequired
};

export default MentionUserItem;
